import {
  convertEventSelectToTarget,
  formatDataToLabelValue,
  Select,
  STATUSPAGE,
} from '@repo/ui';
import {
  GetAllCoursesUserResponse,
  GetAllCurricularUnitsUserResponse,
  GetAllGroupsUserResponse,
  GetAllOrganizationsUserResponse,
  GetAllProfessionalsSelectOptionsResponse,
  GetAllSemestersUserResponse,
} from 'domain/models';
import { FormikProps } from 'formik';
import { Option } from 'presentation/app/models/option';
import { Button, Col, Form, Input, Label, Row, Spinner } from 'reactstrap';

interface IPendingActivitiesFiltersValues {
  entity: Option | null;
  course: Option | null;
  startDate: string;
  endDate: string;
  semester: Option | null;
  unit: Option | null;
  group: Option | null;
  professional: Option | null;
}

interface IProps {
  isManager: boolean;
  validation: FormikProps<IPendingActivitiesFiltersValues>;
  organizations: GetAllOrganizationsUserResponse[];
  courses: GetAllCoursesUserResponse[];
  semesters: GetAllSemestersUserResponse[];
  curricularUnits: GetAllCurricularUnitsUserResponse[];
  groups: GetAllGroupsUserResponse[];
  professionals: GetAllProfessionalsSelectOptionsResponse[];
  statusGet: STATUSPAGE;
  statusExport: STATUSPAGE;
  onExport: (reportFormat: '0' | '1') => void;
}

export const PendingActivitiesFiltersForm = ({
  isManager,
  validation,
  organizations,
  courses,
  semesters,
  curricularUnits,
  groups,
  professionals,
  statusGet,
  statusExport,
  onExport,
}: IProps) => {
  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
        validation.handleSubmit();
      }}
    >
      <Row>
        {isManager && (
          <Col md={6} lg={4} className="mb-3">
            <Label className="form-label">Organização</Label>
            <Select
              isClearable
              name="entity"
              value={validation.values.entity}
              placeholder="Todas"
              onChange={(value) =>
                validation.handleChange(
                  convertEventSelectToTarget('entity', value),
                )
              }
              options={formatDataToLabelValue(
                organizations as never,
                'id',
                'nome',
              )}
            />
          </Col>
        )}

        {isManager && (
          <Col md={6} lg={4} className="mb-3">
            <Label className="form-label">Curso</Label>
            <Select
              isClearable
              name="course"
              value={validation.values.course}
              placeholder="Todos"
              onChange={(value) =>
                validation.handleChange(
                  convertEventSelectToTarget('course', value),
                )
              }
              options={formatDataToLabelValue(courses as never, 'id', 'nome')}
            />
          </Col>
        )}

        <Col md={6} lg={2} className="mb-3">
          <Label htmlFor="startDate" className="form-label">
            Data inicial
          </Label>
          <Input
            type="date"
            id="startDate"
            name="startDate"
            value={validation.values.startDate}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
          />
        </Col>

        <Col md={6} lg={2} className="mb-3">
          <Label htmlFor="endDate" className="form-label">
            Data final
          </Label>
          <Input
            type="date"
            id="endDate"
            name="endDate"
            value={validation.values.endDate}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
          />
        </Col>

        <Col md={6} lg={4} className="mb-3">
          <Label className="form-label">Semestre</Label>
          <Select
            isClearable
            name="semester"
            value={validation.values.semester}
            placeholder="Todos"
            onChange={(value) =>
              validation.handleChange(
                convertEventSelectToTarget('semester', value),
              )
            }
            options={formatDataToLabelValue(semesters as never, 'id', 'nome')}
          />
        </Col>

        <Col md={6} lg={4} className="mb-3">
          <Label className="form-label">Unidade Curricular</Label>
          <Select
            isClearable
            name="unit"
            value={validation.values.unit}
            placeholder="Todos"
            onChange={(value) =>
              validation.setFieldValue('unit', value || null)
            }
            options={formatDataToLabelValue(
              curricularUnits as never,
              'id',
              'nome',
            )}
          />
        </Col>

        <Col md={6} lg={4} className="mb-3">
          <Label className="form-label">Grupo</Label>
          <Select
            isClearable
            name="group"
            value={validation.values.group}
            placeholder="Todos"
            onChange={(value) =>
              validation.setFieldValue('group', value || null)
            }
            options={formatDataToLabelValue(groups as never, 'id', 'nome')}
          />
        </Col>

        <Col md={6} lg={4} className="mb-3">
          <Label className="form-label">Profissional</Label>
          <Select
            isClearable
            name="professional"
            value={validation.values.professional}
            placeholder="Todos"
            onChange={(value) =>
              validation.setFieldValue('professional', value || null)
            }
            options={formatDataToLabelValue(
              professionals as never,
              'id',
              'name',
            )}
          />
        </Col>
      </Row>

      <div className="d-flex justify-content-end gap-2">
        <Button
          color="success"
          type="button"
          onClick={() => onExport('1')}
          disabled={statusExport === STATUSPAGE.LOADING}
        >
          {statusExport === STATUSPAGE.LOADING ? (
            <Spinner size="sm" />
          ) : (
            'Exportar Excel'
          )}
        </Button>
        <Button
          color="danger"
          type="button"
          onClick={() => onExport('0')}
          disabled={statusExport === STATUSPAGE.LOADING}
        >
          {statusExport === STATUSPAGE.LOADING ? (
            <Spinner size="sm" />
          ) : (
            'Exportar PDF'
          )}
        </Button>
        <Button
          color="primary"
          type="submit"
          disabled={statusGet === STATUSPAGE.LOADING}
        >
          {statusGet === STATUSPAGE.LOADING ? (
            <Spinner size="sm" />
          ) : (
            'Visualizar em Tela'
          )}
        </Button>
      </div>
    </Form>
  );
};
